// returns the value of passed enum key as a string with type of union string of enum's keys
function enumValueToString(enumeration, enumValue) {
    return enumValue.toString();
}

export { enumValueToString };
//# sourceMappingURL=enum-value-to-string.js.map
